module.exports = __webpack_public_path__ + "static/media/WorkSans-VariableFont_wght.b2439691.ttf";